import { render, staticRenderFns } from "./indexHomeDISCOpen.vue?vue&type=template&id=2256e26c&scoped=true&"
import script from "./indexHomeDISCOpen.vue?vue&type=script&lang=js&"
export * from "./indexHomeDISCOpen.vue?vue&type=script&lang=js&"
import style0 from "./indexHomeDISCOpen.vue?vue&type=style&index=0&id=2256e26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2256e26c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VRow,VSheet})
